// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__3xnVl","colMaxWidth":"Table_colMaxWidth__33f9r"};